/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unused-prop-types */
import React, { useCallback } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { MdCreditCard, MdBlock, MdRemoveShoppingCart } from 'react-icons/md';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { IoCartOutline } from 'react-icons/io5';
import { BiDollarCircle, BiCalendar } from 'react-icons/bi';
import { IconBaseProps } from 'react-icons';

import { AiFillQuestionCircle, AiFillInfoCircle } from 'react-icons/ai';
import {
  Container,
  AsideMenu,
  AsideItem,
  AsideHeader,
  Separator,
  ToggledAsideItem,
} from './styles';

import logo from '../../../assets/Marca_Transfácil_sem tagline branca.png';
import { ReactComponent as DepartmentsPurple } from '../../../assets/departmentsPurple.svg';
import { ReactComponent as PlusCredit } from '../../../assets/plusCreditCard.svg';
import { ReactComponent as UpdateCircle } from '../../../assets/update.svg';
import AuthService from '../../../services/auth';

interface AsideProps {
  activeMenu(): void;
  activeToggle(): void;
  toggled: boolean;
  actived: boolean;
}
interface NavItem {
  name: string;
  path: string;
  type: string;
  Icon?: React.ComponentType<IconBaseProps> | any;
}

interface NavItens {
  itens: NavItem[];
}

const Aside: React.FC<AsideProps> = ({ activeMenu, activeToggle, toggled }) => {
  const { pathname } = useLocation();
  const [titular, setTitular] = React.useState<any>();
  const authService = { AuthService: new AuthService() };
  const getTitular = useCallback(async () => {
    try {
      const response = await authService.AuthService.getTitular();
      await setTitular(response.data.DadosDoTitular);
    } catch (err) {
      console.error(err);
    }
  }, []);
  const haldleSetMenu = useCallback(() => {
    activeMenu();
  }, [activeMenu]);

  const ToggleMenu = useCallback(() => {
    activeToggle();
  }, [activeToggle]);

  const MinhaEmpresaItems = [
    { name: 'Minha Empresa', path: '/meu-perfil', type: 'header' },
    {
      name: 'Departamentos',
      path: '/departamentos',
      type: 'item',
      Icon: DepartmentsPurple,
    },
    {
      name: 'Funcionários',
      path: '/funcionarios',
      type: 'item',
      Icon: HiOutlineUserGroup,
    },
    {
      name: 'Meus Cartões',
      path: '/cartoes',
      type: 'item',
      Icon: MdCreditCard,
    },
    { name: 'separator1', path: '', type: 'separator' },
  ];

  const MeusPedidosItems = [
    { name: 'Meus Pedidos', path: '/pedidos-de-recarga', type: 'header' },
    {
      name: 'Pedidos de Recarga',
      path: '/pedidos-de-recarga',
      type: 'item',
      Icon: IoCartOutline,
    },
    {
      name: 'Pedidos de Cartão',
      path: '/pedidos-de-cartao',
      type: 'item',
      Icon: PlusCredit,
    },
    { name: 'separator2', path: '', type: 'separator' },
  ];
  const RelatoriosItems = [
    { name: 'Relatórios', path: '/cartoes-sempedido-90dias', type: 'header' },
    {
      name: 'Bloqueados sem 2ª via',
      path: '/cartoes-bloqueados-sem-2via',
      type: 'item',
      Icon: MdBlock,
    },
    {
      name: 'Cartões substituídos',
      path: '/cartoes-substituidos',
      type: 'item',
      Icon: UpdateCircle,
    },
    {
      name: 'Tarifas por linha',
      path: '/tarifas-linha',
      type: 'item',
      Icon: BiDollarCircle,
    },
    {
      name: 'Relatórios Agendados (NOVO)',
      path: '/agendado',
      type: 'item',
      Icon: BiCalendar,
    },
    { name: 'separator3', path: '', type: 'separator' },
  ];
  const AjudaItems = [
    { name: 'Ajuda', path: '/manual', type: 'header' },
    {
      name: 'Manual',
      path: '/manual',
      type: 'item',
      Icon: AiFillQuestionCircle,
    },
    {
      name: 'Suporte',
      path: '/suporte',
      type: 'item',
      Icon: AiFillInfoCircle,
    },
  ];
  const navItens = (): NavItens => {
    // if (titular?.SelectedClient) {
    RelatoriosItems.splice(1, 0, {
      name: 'Sem pedidos por 90 dias',
      path: '/cartoes-sempedido-90dias',
      type: 'item',
      Icon: MdRemoveShoppingCart,
    });
    // }
    return {
      itens: [
        ...MinhaEmpresaItems,
        ...MeusPedidosItems,
        ...RelatoriosItems,
        ...AjudaItems,
      ],
    };
  };

  React.useEffect(() => {
    getTitular();
  }, []);

  return (
    <Container>
      <div className="logo-container">
        <a href="https://transfacil.com.br">
          <img src={logo} alt="logo" />
        </a>
        <button type="button" className="menu-icon" onClick={ToggleMenu}>
          <strong> &#9776;</strong>
        </button>
        <button
          type="button"
          className="menu-responsive-icon"
          onClick={haldleSetMenu}
        >
          <strong> &#9776;</strong>
        </button>
      </div>

      <AsideMenu>
        {navItens().itens.map((item: NavItem) => (
          <>
            {toggled ? (
              <Link to={item.path} key={item.name}>
                {item.type === 'item' && (
                  <ToggledAsideItem active={!!(pathname === item.path)}>
                    <div className="link">
                      {item.Icon && <item.Icon size={20} />}
                    </div>
                  </ToggledAsideItem>
                )}
              </Link>
            ) : (
              <div key={item.name}>
                {item.type === 'header' && (
                  <Link to={item.path}>
                    <AsideHeader>{item.name}</AsideHeader>
                  </Link>
                )}
                {item.type === 'item' && (
                  <Link to={item.path}>
                    <AsideItem active={!!(pathname === item.path)}>
                      <div className="link">
                        {item.Icon && <item.Icon size={20} />}
                        {item.name}
                      </div>
                    </AsideItem>
                  </Link>
                )}
                {item.type === 'separator' && <Separator />}
              </div>
            )}
          </>
        ))}
      </AsideMenu>
    </Container>
  );
};

export default Aside;
